import { useQuery } from "@tanstack/react-query";
import { authClient } from "../lib/auth-client";
import { isNative } from "../lib/platform";
import { getStoreProductPricing } from "../lib/revenueCat";

/**
 * Native only: localized App Store / Play Store prices for every configured
 * product, keyed by product identifier. Resolves to an error (treated as
 * "no store pricing") when RevenueCat isn't configured — callers fall back
 * to the web display prices, which is the dev-environment behaviour.
 */
export function useStoreProductPricing() {
  const { data: session } = authClient.useSession();
  const userId = session?.user?.id;

  return useQuery({
    queryKey: ["storeProductPricing", userId],
    queryFn: () => getStoreProductPricing(userId!),
    enabled: isNative() && !!userId,
    staleTime: 60 * 60 * 1000,
    retry: false,
  });
}
